<template>

    <div class="formClass">
        <div class="page_box">
            <div class="box_top">
                <span class="box_title">我要留言</span>
            </div>
            <div class="box_content">
                <a-form :form="form">
                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="留言类型">
                        <a-select v-decorator="[
                                 'messageTypeId',
                                 {rules: [{ required: true, message: '请选择留言类型' }]}]">
                            <a-select-option v-for="item in msgType.list"
                                             :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item style="text-algin: left;"
                                 :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="校区">
                        <a-select @change="getAllSer"
                                  v-decorator="[
                                 'schoolCampusId',
                                 {rules: [{ required: true, message: '请选择校区' }]}]">
                            <a-select-option v-for="item in allCam"
                                             :value="item.campusId">{{item.campusName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="服务单位">
                        <a-select @change="setdutyRange"
                                  v-decorator="[
                                 'serviceCentreId',
                                 {rules: [{ required: true, message: '请选择服务单位' }]}]">
                            <a-select-option v-for="item in allSer"
                                             :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="职责范围">
                        <p style="width: 100%; min-height: 80px;border: 1px solid #d9d9d9; padding-left: 10px;word-break:break-all;word-wrap:break-word">
                            {{dutyRange}}
                        </p>
                    </a-form-item>
                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="留言内容">
                        <a-textarea :rows="4"
                                    maxlength="200"
                                    v-decorator="[
                                 'content',
                                 {rules: [{ required: true, message: '请输入留言内容' }]}]" />
                    </a-form-item>
                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="图片上传">
                        <div class="clearfix">
                            <a-upload :action="`${http.http}/messageHallHome/uploadPicture`"
                                      listType="picture-card"
                                      :fileList="fileList"
                                      @preview="handlePreview"
                                      accept=".jpg,.png,.jpeg"
                                      @change="handleChange">
                                <div v-if="fileList.length < 3"
                                     style="text-align: center">
                                    <a-icon type="plus" />
                                    <div class="ant-upload-text"
                                         style="text-align: center">点击上传</div>
                                </div>
                            </a-upload>
                            <a-modal :visible="previewVisible"
                                     :footer="null"
                                     @cancel="handleCancel">
                                <img alt="example"
                                     style="width: 100%"
                                     :src="previewImage" />
                            </a-modal>
                        </div>
                    </a-form-item>

                    <a-form-item :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="留言方式">
                        <a-radio-group @change="onChange"
                                       v-model="value">
                            <a-radio :value="1">实名留言</a-radio>
                            <a-radio :value="2"
                                     v-if="isAnonymous">匿名留言</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item v-if="value == 1"
                                 :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="姓名">
                        <a-input v-decorator="[
                                 'userName',
                                 {rules: [{ required: true, message: '请输入姓名' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item v-if="value == 1"
                                 :label-col="formItemLayout.labelCol"
                                 :wrapper-col="formItemLayout.wrapperCol"
                                 label="学号/工号">
                        <a-input v-decorator="[
                                 'number',
                                 {rules: [{ required: true, message: '请输入学号/工号' }]}]"></a-input>
                    </a-form-item>

                    <a-form-item :label-col="formTailLayout.labelCol"
                                 :wrapper-col="formTailLayout.wrapperCol">
                        <a-button type="primary"
                                  style="width: 160px;margin-top: 50px;"
                                  @click="check">
                            提交
                        </a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";
import http from "../../common/config";
const formItemLayout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 8 }
};
const formTailLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 8, offset: 10 }
};
function initView() {
    var ua = navigator.userAgent.toLowerCase();
    var mobile = /mobile/gi.test(ua);
    let isPC = !mobile;
    if (isPC) {
        return 1;
    } else {
        return 0;
    }
}
export default {
    data() {
        return {
            allCam: [],
            allSer: [],
            formItemLayout,
            formTailLayout,
            form: this.$form.createForm(this),
            previewVisible: false,
            previewImage: "",
            fileList: [],
            value: 1,
            dutyRange: "",
            http,
            isAnonymous: false
        };
    },
    computed: {
        ...mapGetters(["msgType", "config"])
    },
    created() {
        this.getAllCam();
        this.$api.getAllowVisistorMessage().then(res => {
            this.isAnonymous = res.param.list[0].allowVisistorMessage;
        });
    },
    methods: {
        handleCancel() {
            this.previewVisible = false;
        },
        handlePreview(file) {
            this.previewImage = file.url || file.thumbUrl;
            this.previewVisible = true;
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
        },
        check() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    values.dataSource = initView();
                    if (this.fileList.length > 0) {
                        values.pictureUrl = [];
                        this.fileList.forEach(item => {
                            values.pictureUrl.push(item.response.param);
                        });
                        values.pictureUrl = JSON.stringify(values.pictureUrl);
                    }

                    this.$api.insertMessage(values).then(res => {
                        if (res.returnCode == "000000") {
                            this.$message.success("提交成功");
                            history.go(-1);
                        } else {
                            this.$message.error(res.returnMsg);
                        }
                    });
                }
            });
        },

        getAllCam() {
            this.$api.getAllCam().then(res => {
                this.allCam = res.param.list;
            });
        },
        getAllSer(id) {
            this.form.setFieldsValue({ serviceCentreId: "" });
            this.dutyRange = "";
            this.$api.getAllSer({ schoolCampusId: id }).then(res => {
                this.allSer = res.param.list;
            });
        },
        setdutyRange(value) {
            this.allSer.forEach(item => {
                if (item.id == value) {
                    this.dutyRange = item.dutyRange;
                }
            });
        }
    }
};
</script>
<style lang="scss" scope>
.formClass .box_content {
    padding: 10px !important;
}
</style>
<style>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>